import styled from "styled-components";
import { breakpoints } from "styles";
import { Container } from "styles/common/container";
import HeroBg from "public/assets/gurujuara/hero-bg.png";

export const BannerWrapper = styled.section`
  background: radial-gradient(
    circle,
    rgba(21, 69, 211, 0.7) 0%,
    rgba(26, 88, 241, 1) 30%,
    rgba(25, 72, 205, 1) 100%
  );
  background:
    url(${HeroBg.src}) center/cover no-repeat,
    radial-gradient(50% 133.09% at 50% 50%, #3a6ae8 0%, #0738c2 100%);
  display: flex;
  position: relative;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  @media ${breakpoints.mobile} {
    padding: 20px;
  }
`;

export const BannerContainer = styled(Container)`
  overflow: hidden;
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 368px;
  justify-content: center;
  align-items: center;
  @media ${breakpoints.mobile} {
    width: auto;
    height: 590px;
    padding: 0;
    justify-content: flex-start;
    gap: 10px;
    margin: 0px;
  }
`;

export const BannerTitle = styled.div`
  font-family: ${({ theme }) => theme.fonts.primary};
  line-height: ${({ theme }) => theme.fontSizes["custom46"]};
  font-size: ${({ theme }) => theme.fontSizes["4xl"]};
  margin-bottom: 32px;
  text-align: center;
  color: ${({ theme }) => theme.colors.white};
  width: 700px;
  font-weight: 700;
  @media ${breakpoints.mobile} {
    margin-bottom: 24px;
    width: 300px;
    font-size: ${({ theme }) => theme.fontSizes["3xl"]};
    line-height: 42px;
    text-align: center;
  }
`;

export const BannerBlockCTA = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  gap: 8px;
  height: 24px;
  z-index: 1;
  width: fit-content;
  cursor: pointer;
  font-weight: bold;
  padding: 12px 24px;
  text-decoration: none;
  font-family: ${({ theme }) => theme.fonts.primary};
  background-color: ${({ theme }) => theme.colors.blue[50]};
  color: ${({ theme }) => theme.colors.blue[800]};
`;

export const BannerContentWrapper = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  align-items: center;
`;

export const BannerImgWrapper = styled.div`
  @media ${breakpoints.mobile} {
    width: 100%;
    height: 100%;
    position: relative;
  }
`;

export const PolaroidWrapper1 = styled.div`
  position: absolute;
  top: 35px;
  left: 25px;
  width: 180px;
  height: 197px;
  z-index: 1;
  @media ${breakpoints.mobile} {
    top: 30px;
    left: 8px;
    width: 200px;
  }
`;

export const PolaroidWrapper2 = styled.div`
  position: absolute;
  top: 125px;
  left: 80px;
  width: 240px;
  height: 197px;
  z-index: 1;
  @media ${breakpoints.mobile} {
    display: none;
  }
`;

export const PolaroidWrapper3 = styled.div`
  position: absolute;
  top: 35px;
  right: 35px;
  width: 180px;
  height: 197px;
  z-index: 1;
  @media ${breakpoints.mobile} {
    top: 60px;
    right: 8px;
    width: 200px;
  }
`;

export const PolaroidWrapper4 = styled.div`
  position: absolute;
  top: 130px;
  right: 80px;
  width: 240px;
  height: 197px;
  z-index: 1;
  @media ${breakpoints.mobile} {
    display: none;
  }
`;

export const BannerGrid = styled.div`
  @media ${breakpoints.mobile} {
    rotate: 90deg;
    scale: 3;
    z-index: 0;
  }
`;
